import React from 'react';

// import * as clevertapItem from 'clevertap/inventory/item';
import ItemVariantField from './ItemVariantField';
import styles from '../ItemVariantModal.css';

class ItemVariantFieldArray extends React.Component {
  render() {
    const {
      fields,
      ingredientSubscriptionDetail,
      isSalesTypePrice,
      ecommerceAttributes,
      isEcommerceFashion,
    } = this.props;
    return (
      <div className="row">
        {!isEcommerceFashion && (
          <div className="form-group col-sm-12 mb-0px">
            <a className="btn btn-primary btn-block" onClick={this._onClickAdd}>
              Add Variant
            </a>
          </div>
        )}
        {isEcommerceFashion && (
          <ItemVariantField
            isSalesTypePrice={isSalesTypePrice}
            index={-1}
            ecommerceAttributes={ecommerceAttributes}
          />
        )}
        {fields.map((member, index) => {
          return (
            <ItemVariantField
              key={index}
              member={member}
              isSalesTypePrice={isSalesTypePrice}
              isRecipe={
                ingredientSubscriptionDetail.is_active &&
                fields.get(index).is_recipe
              }
              ecommerceAttributes={ecommerceAttributes}
              index={index}
              showDelete={fields.length > 1}
              onDelete={() => this._onDelete(index)}
            />
          );
        })}
        {isEcommerceFashion && (
          <div className="form-group col-md-4 mt-20px">
            <button
              className={`btn btn-block ${styles['btn-outline-primary']}`}
              onClick={this._onClickAdd}
              type="button"
            >
              + Add Custom Variant
            </button>
          </div>
        )}
      </div>
    );
  }

  _onDelete = index => {
    const { fields } = this.props;
    // clevertapItem.inventoryItemVariantDeleteVariantOnModal({
    //   outletIds,
    //   name: fields.get(index).name,
    // });
    fields.remove(index);
  };

  _onClickAdd = () => {
    const { fields, salesType, isSalesTypePrice } = this.props;
    const initialValue = {
      name: '',
      price: null,
      sku: '',
      in_stock: 0,
      stock_alert: 0,
      cogs: null,
      saved_cogs: false,
      is_saved: false,
      is_editable: true,
      is_new: true,
    };
    // clevertapItem.inventoryItemVariantAddCustomVariant(outletIds);
    if (isSalesTypePrice) {
      const salesTypeItems = [];
      salesType
        .filter(e => e.selected)
        .map(st => {
          salesTypeItems.push({
            sales_type_id: st.id,
          });
        });
      initialValue.sales_type_items = salesTypeItems;
    }
    fields.push(initialValue);
  };
}

export default ItemVariantFieldArray;
